import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function CalendarPerson(props: SvgIconProps) {
  const { fill = "white", ...otherProps } = props;

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.59 2.06V0.67C11.59 0.3 11.28 0 10.9 0C10.52 0 10.21 0.3 10.21 0.67V2.01H4.87999V0.67C4.87999 0.3 4.56999 0 4.18999 0C3.80999 0 3.49999 0.3 3.49999 0.67V2.05C1.52999 2.27 -0.0100098 4.03 -0.0100098 6.21V11.85C-0.0100098 12.34 0.0699902 12.8 0.21999 13.25C0.58999 14.38 1.37999 15.28 2.39999 15.74C2.85999 15.95 3.36999 16.07 3.90999 16.07H7.04999V14.72H3.90999C2.84999 14.72 1.92999 14.06 1.50999 13.08C1.34999 12.71 1.24999 12.29 1.24999 11.86V7.37H13.83V8.1H15.09V6.21C15.09 4.03 13.55 2.27 11.58 2.05L11.59 2.06ZM1.26999 6.03C1.34999 4.69 2.28999 3.61 3.50999 3.41V4.62C3.50999 4.99 3.81999 5.29 4.19999 5.29C4.57999 5.29 4.88999 4.99 4.88999 4.62V3.37H10.22V4.62C10.22 4.99 10.53 5.29 10.91 5.29C11.29 5.29 11.6 4.99 11.6 4.62V3.41C12.82 3.61 13.76 4.69 13.84 6.03H1.26999ZM11.96 8.62C10.12 8.62 8.62999 10.02 8.62999 11.74C8.62999 13.46 10.12 14.86 11.96 14.86C13.8 14.86 15.29 13.46 15.29 11.74C15.29 10.02 13.8 8.62 11.96 8.62ZM9.79999 11.74C9.79999 10.63 10.77 9.73 11.96 9.73C13.15 9.73 14.12 10.63 14.12 11.74C14.12 12.85 13.15 13.75 11.96 13.75C10.77 13.75 9.79999 12.85 9.79999 11.74ZM11.95 15.73C13.36 15.72 14.71 16.18 15.79 17.02H15.77C16.02 17.22 16.05 17.57 15.85 17.8C15.65 18.03 15.27 18.06 15.02 17.86C14.16 17.19 13.07 16.82 11.94 16.82C10.81 16.82 9.71999 17.19 8.85999 17.86C8.60999 18.06 8.23999 18.03 8.02999 17.8C7.81999 17.57 7.85999 17.22 8.10999 17.02C9.18999 16.18 10.55 15.73 11.95 15.73Z"
        fill={fill}
      />
    </SvgIcon>
  );
}
